/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Route configuration
  ============================================================

  Kaikki julkiset FI / EN -reitit määritetään täällä.

  Tätä samaa dataa voidaan myöhemmin käyttää:
  - React Routerissa
  - kielenvaihdossa
  - canonical-osoitteissa
  - hreflang-linkeissä
  - sitemap.xml-generoinnissa
  - build-time SEO HTML -sivuissa

  Näin URL-rakennetta ei kovakoodata moneen eri paikkaan.
*/

export const routeConfig = {
  home: {
    id: "home",

    paths: {
      fi: "/",
      en: "/en/",
    },
  },

  portfolio: {
    id: "portfolio",

    paths: {
      fi: "/portfolio",
      en: "/en/portfolio",
    },
  },

  services: {
    id: "services",

    paths: {
      fi: "/kuvaukset",
      en: "/en/sessions",
    },
  },

  studio: {
    id: "studio",

    paths: {
      fi: "/studio",
      en: "/en/studio",
    },
  },

  pricing: {
    id: "pricing",

    paths: {
      fi: "/hinnasto",
      en: "/en/pricing",
    },
  },

  about: {
    id: "about",

    paths: {
      fi: "/kuvaaja",
      en: "/en/about",
    },
  },

  contact: {
    id: "contact",

    paths: {
      fi: "/yhteys",
      en: "/en/contact",
    },
  },
};

/*
  Poistetaan loppukauttaviiva vertailua varten.

  Esimerkiksi:
  /en/
  /en

  käsitellään samana reittinä.
*/

export function normalizePath(
  pathname = "/"
) {
  const cleanPath =
    String(
      pathname || "/"
    ).trim();

  if (
    !cleanPath ||
    cleanPath === "/"
  ) {
    return "/";
  }

  return (
    cleanPath.replace(/\/+$/, "") ||
    "/"
  );
}

/*
  Selvitetään URL:n perusteella sivun kieli.

  /en
  /en/...
  = englanti

  Kaikki muut julkiset reitit
  = suomi
*/

export function getLanguageFromPath(
  pathname = "/"
) {
  const normalizedPath =
    normalizePath(
      pathname
    ).toLowerCase();

  if (
    normalizedPath === "/en" ||
    normalizedPath.startsWith(
      "/en/"
    )
  ) {
    return "en";
  }

  return "fi";
}

/*
  Haetaan route-id:n ja kielen perusteella oikea URL.
*/

export function getRoutePath(
  routeId,
  language = "fi"
) {
  const route =
    routeConfig[routeId];

  if (!route) {
    return language === "en"
      ? "/en/"
      : "/";
  }

  return (
    route.paths[language] ||
    route.paths.fi ||
    "/"
  );
}

/*
  Selvitetään nykyisen pathname-arvon perusteella,
  mikä looginen sivu on kyseessä.

  Tämä mahdollistaa esimerkiksi:

  /kuvaaja
  -> vaihda EN
  -> /en/about

  eikä käyttäjää heitetä aina etusivulle.
*/

export function findRouteByPath(
  pathname = "/"
) {
  const normalizedPath =
    normalizePath(
      pathname
    );

  return (
    Object.values(
      routeConfig
    ).find(
      (route) => {
        return Object.values(
          route.paths
        ).some(
          (path) => {
            return (
              normalizePath(
                path
              ) ===
              normalizedPath
            );
          }
        );
      }
    ) || null
  );
}

export default routeConfig;